export type PageItem = number | "ellipsis";

/**
 * 窗口页码算法(#7):current/total 均 1-based。首末页常驻,当前页两侧各展示 `siblings`
 * 个;与首/末之间有间隔时插 "ellipsis"。少页时全展开、不出省略号。
 */
export function computePageItems(current: number, total: number, siblings = 1): PageItem[] {
  if (total <= 1) return [1];
  const first = 1;
  const last = total;
  const start = Math.max(first + 1, current - siblings);
  const end = Math.min(last - 1, current + siblings);
  const items: PageItem[] = [first];
  if (start > first + 1) items.push("ellipsis");
  for (let p = start; p <= end; p++) items.push(p);
  if (end < last - 1) items.push("ellipsis");
  items.push(last);
  return items;
}
